import { ThemeProvider, createTheme } from '@mui/material/styles';

// import { deDE as dataGridDeDE } from '@mui/x-data-grid';
import { esES as coreesES } from '@mui/material/locale';
import { esES } from '@mui/x-date-pickers/locales';

// xs	Hasta 599
// sm	600 hasta 991
// md	992 hasta 1199
// lg	1200 hasta 1499
// xl	1500 en adelante

const S10Blueblue50 = "#E8F3F7"
const S10Blueblue100 = "#B7DAE6"
const S10Blueblue300 = "#63AFC8"
const S10Blueblue600 = "#3C8DBC"
const S10Blueblue700 = "#10617B"
const S10Greygrey50 = "#E8E8E8"
const S10Greygrey100 = "#B8B8B8"
const S10Greygrey150 = "#8AA4AF"
const S10Greygrey300 = "#666"
const S10Greygrey350 = "#2C3B41"
const S10Greygrey400 = "#494949"
const S10Greygrey450 = "#1e282c"
const S10Greygrey500 = "#1B1B1B"
const S10Greygrey600 = "#191919"
const S10Greygrey700 = "#131313"
const S10Greygrey900 = "#191919"
const S10Redred500 = "#B50808";
const S10Greengreen50 = "#E8F7F1"
const S10Greengreen100 = "#B7E6D2"
const S10Greengreen500 = "#17AD6F"
const S10Greengreen700 = "#107B4F"

declare module '@mui/material/styles' {
  interface Theme {
    s10palette: {
      S10Blueblue50: string,
      S10Blueblue100: string,
      S10Greygrey150: string,
      S10Blueblue300: string,
      S10Greygrey350: string,
      S10Blueblue600: string,
      S10Blueblue700: string,
      S10Greygrey50: string,
      S10Greygrey100: string,
      S10Greygrey300: string,
      S10Greygrey400: string,
      S10Greygrey450: string,
      S10Greygrey500: string,
      S10Greygrey600: string,
      S10Greygrey700: string,
      S10Greygrey900: string,
      S10Redred500: string,
      S10Greengreen50: string,
      S10Greengreen100: string,
      S10Greengreen500: string,
      S10Greengreen700: string,
    }
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    s10palette?: {
      S10Blueblue50: string,
      S10Blueblue100: string,
      S10Greygrey150: string,
      S10Blueblue300: string,
      S10Greygrey350: string,
      S10Blueblue600: string,
      S10Blueblue700: string,
      S10Greygrey50: string,
      S10Greygrey100: string,
      S10Greygrey300: string,
      S10Greygrey400: string,
      S10Greygrey450: string,
      S10Greygrey500: string,
      S10Greygrey600: string,
      S10Greygrey700: string,
      S10Greygrey900: string,
      S10Redred500: string,
      S10Greengreen50: string,
      S10Greengreen100: string,
      S10Greengreen500: string,
      S10Greengreen700: string,
    }
  }
}

let theme = createTheme({
  s10palette: {
    S10Blueblue50,
    S10Blueblue100,
    S10Greygrey150,
    S10Blueblue300,
    S10Greygrey350,
    S10Blueblue600,
    S10Blueblue700,
    S10Greygrey50,
    S10Greygrey100,
    S10Greygrey300,
    S10Greygrey400,
    S10Greygrey450,
    S10Greygrey500,
    S10Greygrey600,
    S10Greygrey700,
    S10Redred500,
    S10Greygrey900,
    S10Greengreen50,
    S10Greengreen100,
    S10Greengreen500,
    S10Greengreen700,
  },
  typography: {
    button: {
      textTransform: 'none'
    }
  },
  components: {
    MuiTypography: {
      variants: [
        {
          props: { variant: 'h3' },
          style: {
            color: S10Blueblue600,
            fontFamily: "Roboto",
            fontSize: "2rem",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'h5' },
          style: {
            color: S10Greygrey700,
            fontFamily: "Roboto",
            fontSize: "1.5rem",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'h6' },
          style: {
            color: S10Greygrey700,
            fontFamily: "Roboto",
            fontSize: "1.125rem",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'subtitle1' },
          style: {
            color: S10Greygrey900,
            fontFamily: "Roboto",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'subtitle2' },
          style: {
            color: S10Greygrey900,
            fontFamily: "Roboto",
            fontSize: "0.875rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'body1' },
          style: {
            color: S10Greygrey400,
            fontFamily: "Roboto",
            fontSize: "0.75rem",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "normal",
          }
        },
        {
          props: { variant: 'body2' },
          style: {
            color: S10Greygrey400,
            fontFamily: "Roboto",
            fontSize: "0.75rem",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "normal",
          }
        },
      ],
    },
    MuiTextField: {
      defaultProps: {
      },
      styleOverrides: {
        root: {
          marginTop: "0.25rem",
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: "none",
              // borderColor: 'none',
            },
            '&:hover fieldset': {
              border: `1px solid ${S10Blueblue700}`,
            },
            '&.Mui-focused fieldset': {
              border: `2px solid ${S10Blueblue700}`,
            },
          },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
        color: S10Greygrey600,
        fontFamily: 'Roboto',
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "normal",
        '&.Mui-selected': {
          backgroundColor: "transparent",
          color: `${S10Blueblue600} !important`,
          fontWeight: "700 !important",
        }
      }
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          // marginTop: "0.25rem",
          // height: "2.5rem",
          width: "100%",
          border: "1px solid #B8B8B8",
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: "none",
              // borderColor: 'none',
            },
            '&:hover fieldset': {
              border: `1px solid ${S10Blueblue700}`,
            },
            '&.Mui-focused fieldset': {
              border: `2px solid ${S10Blueblue700}`,
            },
          },
        },
      },

    }
  },
  palette: {
    primary: {
      main: S10Blueblue700,
    },
    // secondary: {
    //   main: '#edf2ff',
    // },
  },
}, esES, coreesES);

export interface ThemeProviderProps {
  children: React.ReactNode;
}
const MyThemeProvider = ({children}: ThemeProviderProps) => {
    return (
        <ThemeProvider theme={theme}>
          {children}
        </ThemeProvider>

    )
}

export default MyThemeProvider;